export const data = [
  {
    id: "1",
    name: "Login page – performance issues",
    description: "This task has no description",
    isBacklog: true,
    isReady: false,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "2",
    name: "Sprint bugfix",
    description: "This task has no description",
    isBacklog: true,
    isReady: false,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "3",
    name: "Shop page – performance issues",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "4",
    name: "Checkout bugfix",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },

  {
    id: "5",
    name: "Shop bug1",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },

  {
    id: "6",
    name: "Shop bug2",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },

  {
    id: "7",
    name: "Shop bug3",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },

  {
    id: "8",
    name: "Shop bug4",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "9",
    name: "Shop bug5",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "10",
    name: "Shop bug6",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "11",
    name: "Shop page – performance issues",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "12",
    name: "User page – performance issues",
    description: "This task has no description",
    isBacklog: false,
    isReady: false,
    isProgress: true,
    isFinished: false,
  },
  {
    id: "13",
    name: "Auth bugfix",
    description: "This task has no description",
    isBacklog: false,
    isReady: false,
    isProgress: true,
    isFinished: false,
  },
  {
    id: "14",
    name: "Main page – performance issues",
    description: "This task has no description",
    isBacklog: false,
    isReady: true,
    isProgress: false,
    isFinished: false,
  },
  {
    id: "15",
    name: "Main page bugfix",
    description: "This task has no description",
    isBacklog: false,
    isReady: false,
    isProgress: false,
    isFinished: true,
  },
];
